import React, { useEffect, useRef } from 'react'
import { Form, Input, Button, Typography } from 'antd'

import { Box } from 'layout'

export default function ScreenGetNickname ({ onFinish, onFinishFailed }) {
  const nicknameInputRef = useRef(null)
  const [form] = Form.useForm()
  const { Title } = Typography

  useEffect(() => {
    nicknameInputRef.current.focus()
  }, [])

  return (
    <Box>
      <Title level={5}>Inform your nickname to enter the chat for unscramble</Title>
      <Form form={form} name='basic' onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete='off' layout='inline'>
        <Form.Item name='nickname' rules={[{ required: true, message: 'Please input your nickname!' }]}>
          <Input placeholder='Nickname' ref={nicknameInputRef} />
        </Form.Item>

        <Form.Item shouldUpdate>
          {() => (
            <Button type='primary' htmlType='submit' disabled={!form.isFieldsTouched(true) || !!form.getFieldsError().filter(({ errors }) => errors.length).length}>
              Go chatting
            </Button>
          )}
        </Form.Item>
      </Form>
    </Box>
  )
}
